export const HOME = '/'
export const SUPERX = '/superx'
export const LOGIN_PERMISSION = "/login-permission";
export const CONTACT = "/enquiry-form";
export const ABOUTUS = "/about-us";
export const TANDC = "/terms";
export const REFUND_POLICY = "/refund";
export const COURSES = "/courses";
export const PLACEMENTS = "/placements";
export const COMPANIES = "/companies"
export const COURSEDETAILS = '/courses'
export const EVENTSDETAILS = '/event-details'
export const QUIZEETHON = '/quizeethon-event'
export const SUPERXPROJECTS = '/superx-projects'
export const SUPERXTESTIMONIALS = '/testimonials'
export const SUPERXALLBATCHE = '/superx-batch'
export const SUPERXPROJECTDETAILS = '/superx-project'
export const OFFLINECOURSE = '/Offline-courses'
export const AITOOLBOOTCAMP1 = '/course/ai-tools-bootcamp'
export const AITOOLBOOTCAMP2 = '/ai-tools-bootcamp'
export const SIGNUP = '/signup'
export const LOGIN = '/login'
export const UPCOMING_COURSE = '/upcoming-course'
export const FULLSTACK_COURSE = '/full-stack-development'

